// action
import {
    DELETE_ROLE,
    DELETE_ROLE_FAIL,
    DELETE_ROLE_SUCCESS,
    DELETE_ROLE_RESET
} from '../action/deleteRoleAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case DELETE_ROLE:
            return {
                ...state,
                apiState: "loading"
            }
        case DELETE_ROLE_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case DELETE_ROLE_SUCCESS:
            return {
                ...state,
                apiState: "success",
                message: action.response.data.message,
            }
        case DELETE_ROLE_RESET:
            return initialState
        default:
            return state
    }
}